import { render, staticRenderFns } from "./idCardEdit.vue?vue&type=template&id=ddb9a978&scoped=true&"
import script from "./idCardEdit.vue?vue&type=script&lang=js&"
export * from "./idCardEdit.vue?vue&type=script&lang=js&"
import style0 from "./idCardEdit.vue?vue&type=style&index=0&id=ddb9a978&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb9a978",
  null
  
)

export default component.exports